/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownLeftIcon16Light = forwardRef('ArrowDCornerDownLeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.5 10A2.5 2.5 0 0 0 14 7.5v-6a.5.5 0 1 0-1 0v6A1.5 1.5 0 0 1 11.5 9H3.207l3.647-3.646a.5.5 0 1 0-.708-.708L2.495 8.298a1.7 1.7 0 0 0 0 2.404l3.651 3.652a.5.5 0 0 0 .708-.708L3.207 10H11.5Z" })));
});
